export default __webpack_public_path__ + "static/media/folk-blue.4ee3be1a.svg";